import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import withLayout from '../../../hocs/Layout';
import TrackBox from './trackBox';
import TrackingListitem from './trackingListItem';
import PageTitle from '../../../common/PageTitle';
import { pageContainerSx } from '../../../styles/patterns';

const ListTracking = () => {
  const { trackingListInfo } = useSelector((state) => state.trackingListSlice);

  return (
    <Box sx={pageContainerSx}>
      <PageTitle subTitle="Track shipments by AWB and view live status">Shipment Tracking</PageTitle>
      <TrackBox />
      <TrackingListitem trackingListInfo={trackingListInfo} />
    </Box>
  );
};

export default withLayout(ListTracking);
